import { render, staticRenderFns } from "./AddPerson.vue?vue&type=template&id=20431bc4&scoped=true&"
import script from "./AddPerson.vue?vue&type=script&lang=js&"
export * from "./AddPerson.vue?vue&type=script&lang=js&"
import style0 from "./AddPerson.vue?vue&type=style&index=0&id=20431bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20431bc4",
  null
  
)

export default component.exports